module.exports = __webpack_public_path__ + "public/img/qiaqia_logo.6a07ce9d.png";